module.exports = __webpack_public_path__ + "static/media/wow.d4d1cbfb.png";